import { Card, CardContent } from '@shared/components/ui/shadcn/card';
import { useTranslation } from 'react-i18next';

interface SummaryCardsProps {
  total: number;
  migratedCount: number;
  notMigratedCount: number;
  avgOrdersPerMonth: number;
}

export const SummaryCards = ({ total, migratedCount, notMigratedCount, avgOrdersPerMonth }: SummaryCardsProps) => {
  const { t } = useTranslation('legacyDashboardModule');

  const cards = [
    { label: t('summary.total'), value: total.toLocaleString() },
    { label: t('summary.migrated'), value: migratedCount.toLocaleString() },
    { label: t('summary.not_migrated'), value: notMigratedCount.toLocaleString() },
    {
      label: t('summary.avg_orders'),
      value: avgOrdersPerMonth.toLocaleString(undefined, { maximumFractionDigits: 2 }),
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {cards.map((card) => (
        <Card key={card.label} className="border-border bg-card">
          <CardContent className="p-4">
            <p className="text-xs text-muted-foreground">{card.label}</p>
            <p className="text-2xl font-semibold text-foreground mt-1">{card.value}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
